import { render } from "./CalendarOrganize.vue?vue&type=template&id=286f8d34"
import script from "./CalendarOrganize.vue?vue&type=script&lang=js"
export * from "./CalendarOrganize.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__